const CARDS = [
  {
    id: 1,
    title: '必看！2026年最值得期待的10部国产电影',
    excerpt: '从科幻巨制到现实主义题材，今年国产电影迎来了前所未有的爆发期。我们整理了10部不容错过的重磅作品。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20film%20production%20aesthetic%20with%20warm%20theater%20lighting%20and%20film%20set%20atmosphere%2C%20dramatic%20red%20and%20gold%20color%20palette%2C%20movie%20making%20essence%2C%20no%20text%2C%20no%20faces%2C%20elegant%20composition&width=600&height=380&seq=card-01-chinese&orientation=landscape',
    tag: '编辑精选',
    date: '2026-07-30',
  },
  {
    id: 2,
    title: '从《肖申克》到《寄生虫》：影史必看的50部神作',
    excerpt: '跨越时代和国界的电影经典，每一部都在讲述人性的光辉与黑暗。这份片单是每个影迷的必修课。',
    image: 'https://readdy.ai/api/search-image?query=Classic%20film%20history%20montage%20aesthetic%20with%20vintage%20movie%20posters%20and%20film%20reels%2C%20warm%20sepia%20and%20gold%20tones%2C%20nostalgic%20cinema%20atmosphere%2C%20no%20text%2C%20no%20faces%2C%20timeless%20composition&width=600&height=380&seq=card-02-classics&orientation=landscape',
    tag: '影史经典',
    date: '2026-07-28',
  },
  {
    id: 3,
    title: '如何在家打造影院级观影体验？设备与设置全攻略',
    excerpt: '不缓冲影院体验不仅依赖网速，合理的设备搭配和环境设置同样重要。从音响到屏幕，一篇讲透。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20aesthetic%20with%20warm%20ambient%20lighting%20and%20minimalist%20interior%2C%20cozy%20cinema%20room%20atmosphere%2C%20dark%20walls%20with%20accent%20lighting%2C%20no%20text%2C%20elegant%20composition&width=600&height=380&seq=card-03-hometheater&orientation=landscape',
    tag: '观影指南',
    date: '2026-07-26',
  },
  {
    id: 4,
    title: '8090年代的港片为什么让人念念不忘？',
    excerpt: '从《英雄本色》到《重庆森林》，黄金时代的港片承载了一代人的青春。我们聊聊那些经典背后的故事。',
    image: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20cinema%20nostalgia%20aesthetic%20with%20neon%20signs%20and%20rain-slicked%20streets%2C%20vintage%20film%20poster%20wall%2C%20warm%20amber%20and%20teal%20contrast%2C%20retro%20movie%20atmosphere%2C%20no%20text%2C%20no%20faces%2C%20dreamy%20composition&width=600&height=380&seq=card-04-hknostalgia&orientation=landscape',
    tag: '影评专栏',
    date: '2026-07-24',
  },
  {
    id: 5,
    title: '电影字幕组的前世今生：你不知道的幕后故事',
    excerpt: '每一部你能看到的国外电影背后，都有一群默默奉献的字幕组成员。这是关于热爱与坚持的故事。',
    image: 'https://readdy.ai/api/search-image?query=Film%20editing%20and%20subtitling%20workspace%20aesthetic%20with%20warm%20screen%20glow%20and%20dark%20ambient%20lighting%2C%20creative%20post-production%20atmosphere%2C%20cinematic%20color%20grading%20theme%2C%20no%20text%2C%20no%20faces%2C%20focused%20composition&width=600&height=380&seq=card-05-subtitle&orientation=landscape',
    tag: '幕后故事',
    date: '2026-07-22',
  },
  {
    id: 6,
    title: '2026暑期档观影指南：哪些电影值得去影院？',
    excerpt: '今年暑期档竞争激烈，好莱坞大片与国产力作同台竞技。我们帮你梳理最值得关注的几部新片。',
    image: 'https://readdy.ai/api/search-image?query=Summer%20movie%20theater%20exterior%20aesthetic%20with%20warm%20golden%20sunset%20lighting%2C%20cinema%20marquee%20and%20film%20posters%2C%20festive%20movie%20season%20atmosphere%2C%20no%20text%2C%20no%20faces%2C%20inviting%20composition&width=600&height=380&seq=card-06-summerguide&orientation=landscape',
    tag: '观影指南',
    date: '2026-07-20',
  },
  {
    id: 7,
    title: '从IMDb到豆瓣：全球电影评分体系大对比',
    excerpt: '不同平台的评分标准有何差异？为什么有些电影在国外评价很高但国内口碑平平？一文读懂评分背后的逻辑。',
    image: 'https://readdy.ai/api/search-image?query=Film%20criticism%20and%20review%20aesthetic%20with%20movie%20scripts%20and%20rating%20stars%2C%20warm%20study%20lighting%2C%20intellectual%20cinema%20discussion%20atmosphere%2C%20no%20text%2C%20no%20faces%2C%20thoughtful%20composition&width=600&height=380&seq=card-07-rating&orientation=landscape',
    tag: '深度解析',
    date: '2026-07-18',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100/60">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            影视资讯
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            最新的电影资讯、深度影评和观影指南，让8090影院成为你的影视信息中心
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CARDS.slice(0, 6).map((card) => (
            <article
              key={card.id}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/30 hover:border-primary-500/15 transition-all duration-300 cursor-pointer group"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-[10px] font-semibold bg-primary-500 text-background-50">
                  {card.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-sm font-heading font-bold text-foreground-800 mb-2.5 leading-snug line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">{card.excerpt}</p>
                <div className="flex items-center justify-between">
                  <span className="text-[11px] text-foreground-400">{card.date}</span>
                  <span className="text-xs text-primary-500 font-medium group-hover:translate-x-0.5 transition-transform inline-flex items-center gap-1">
                    阅读全文 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}

          <article className="bg-background-50 rounded-xl overflow-hidden border border-background-200/30 hover:border-primary-500/15 transition-all duration-300 cursor-pointer group sm:col-span-2 lg:col-span-3">
            <div className="flex flex-col sm:flex-row">
              <div className="relative h-48 sm:h-auto sm:w-72 flex-shrink-0 overflow-hidden">
                <img
                  src={CARDS[6].image}
                  alt={CARDS[6].title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent to-background-50/50 sm:bg-gradient-to-t sm:from-background-50/80 sm:via-transparent sm:to-transparent"></div>
              </div>
              <div className="p-5 md:p-6 flex-1 flex flex-col justify-center">
                <span className="px-2.5 py-1 rounded-full text-[10px] font-semibold bg-primary-500 text-background-50 w-fit mb-3">
                  {CARDS[6].tag}
                </span>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-800 mb-2.5 leading-snug">
                  {CARDS[6].title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">{CARDS[6].excerpt}</p>
                <div className="flex items-center justify-between">
                  <span className="text-[11px] text-foreground-400">{CARDS[6].date}</span>
                  <span className="text-xs text-primary-500 font-medium group-hover:translate-x-0.5 transition-transform inline-flex items-center gap-1">
                    阅读全文 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}